import PropTypes from 'prop-types';
import { CONNECTION_TYPES } from './constants';

export const connectionItemShape = PropTypes.shape({
    id: PropTypes.string.isRequired,
    type: PropTypes.oneOf(Object.values(CONNECTION_TYPES)).isRequired,
    name: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
    statusText: PropTypes.string,
    Logo: PropTypes.elementType.isRequired,
    connected: PropTypes.bool.isRequired,
    busy: PropTypes.bool.isRequired,
    onConnect: PropTypes.func.isRequired,
    onDisconnect: PropTypes.func.isRequired,
});
